import { render } from "./HorarioPlantilla.vue?vue&type=template&id=6eda08aa"
import script from "./HorarioPlantilla.vue?vue&type=script&lang=js"
export * from "./HorarioPlantilla.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__